import { render, staticRenderFns } from "./ProductList24TshirtV3.vue?vue&type=template&id=b652d95c"
import script from "./ProductList24TshirtV3.vue?vue&type=script&lang=js"
export * from "./ProductList24TshirtV3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports